import type { SubdivisionCatalog } from "./types";

/**
 * Chile — 16 regions. Santiago is not a separate district here: it is `CL-RM`, an ordinary region.
 *
 * Two rows keep long official names that nobody says out loud, so both carry the everyday short form as an
 * alias.
 */
export const CHL_SUBDIVISIONS: SubdivisionCatalog = [
  // ISO spells it "Aisén"; the region itself and everyone in it write "Aysén".
  { code: "CL-AI", name: "Aisén del General Carlos Ibañez del Campo", aliases: ["Aysén"] },
  { code: "CL-AN", name: "Antofagasta" },
  { code: "CL-AP", name: "Arica y Parinacota" },
  { code: "CL-AT", name: "Atacama" },
  { code: "CL-BI", name: "Biobío" },
  { code: "CL-CO", name: "Coquimbo" },
  { code: "CL-AR", name: "La Araucanía" },
  { code: "CL-LI", name: "Libertador General Bernardo O'Higgins", aliases: ["O'Higgins"] },
  { code: "CL-LL", name: "Los Lagos" },
  { code: "CL-LR", name: "Los Ríos" },
  { code: "CL-MA", name: "Magallanes" },
  { code: "CL-ML", name: "Maule" },
  { code: "CL-NB", name: "Ñuble" },
  { code: "CL-RM", name: "Región Metropolitana de Santiago", aliases: ["Santiago", "RM"] },
  { code: "CL-TA", name: "Tarapacá" },
  { code: "CL-VS", name: "Valparaíso" },
];
